import React from 'react';
import { DownOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { GlobalToken } from 'antd';

interface IconButtonProps {
  icon: React.ReactNode;
  label?: string;
  showDropdown?: boolean;
  onClick?: () => void;
  className?: string;
}

const ButtonContainer = styled.button<{ theme: { token: GlobalToken } }>`
  display: flex;
  align-items: center;
  gap: ${({ theme: { token } }) => token.marginXXS}px;
  padding: ${({ theme: { token } }) => token.paddingXS}px ${({ theme: { token } }) => token.paddingSM}px;
  background: transparent;
  border: none;
  border-radius: ${({ theme: { token } }) => token.borderRadiusSM}px;
  color: ${({ theme: { token } }) => token.colorText};
  font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 24px;
  line-height: 1;

  &.no-padding-left {
    padding-left: 0;
  }

  &:hover {
    background: ${({ theme: { token } }) => token.colorFillQuaternary};
  }

  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .label {
    white-space: nowrap;
  }

  .dropdown-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 12px;
  }
`;

const IconButton: React.FC<IconButtonProps> = ({ icon, label, showDropdown = false, onClick, className }) => {
  return (
    <ButtonContainer onClick={onClick} className={className}>
      {icon && <span className="icon-wrapper">{icon}</span>}
      {label && <span className="label">{label}</span>}
      {showDropdown && (
        <span className="dropdown-icon">
          <DownOutlined style={{ fontSize: '12px' }} />
        </span>
      )}
    </ButtonContainer>
  );
};

export default IconButton;
